export const DEFAULT_USD_LIMIT = 20000;
